(function () {
  function initBannerCarousel(root) {
    if (root.dataset.bannerCarouselInit) return;
    root.dataset.bannerCarouselInit = 'true';

    const track = root.querySelector('.product-metafield-banners__track');
    const slides = Array.from(root.querySelectorAll('[data-banner-slide]'));
    const pagination = root.querySelector('.slideshow-pagination');
    const pageBtns = pagination ? Array.from(pagination.querySelectorAll('.page-btn')) : [];

    if (!track || slides.length === 0) return;

    let currentIndex = 0;
    let scrollRaf = null;

    const getSlideSpan = () => {
      if (slides.length < 2) return track.clientWidth;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    };

    const getIndexFromScroll = () => {
      const span = getSlideSpan();
      if (!span) return 0;
      return Math.round(track.scrollLeft / span);
    };

    const setActiveIndex = (index, behavior = 'smooth') => {
      const total = slides.length;
      if (total === 0) return;

      let nextIndex = index;
      if (nextIndex < 0) nextIndex = total - 1;
      if (nextIndex >= total) nextIndex = 0;

      currentIndex = nextIndex;
      const span = getSlideSpan();

      track.scrollTo({
        left: span * nextIndex,
        behavior
      });

      slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === nextIndex ? 'false' : 'true');
      });

      pageBtns.forEach((btn, btnIndex) => {
        if (btnIndex === nextIndex) {
          btn.setAttribute('aria-current', 'true');
        } else {
          btn.removeAttribute('aria-current');
        }
      });
    };

    const onScroll = () => {
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(() => {
        const index = getIndexFromScroll();
        if (index === currentIndex) return;

        currentIndex = index;
        slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
        });
        pageBtns.forEach((btn, btnIndex) => {
          if (btnIndex === index) {
            btn.setAttribute('aria-current', 'true');
          } else {
            btn.removeAttribute('aria-current');
          }
        });
      });
    };

    if (pagination) {
      pagination.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button || !pagination.contains(button)) return;

        if (button.name === 'next') {
          setActiveIndex(currentIndex + 1);
          return;
        }

        if (button.name === 'prev') {
          setActiveIndex(currentIndex - 1);
          return;
        }

        if (button.matches('.page-btn')) {
          setActiveIndex(Number(button.dataset.index));
        }
      });
    }

    track.addEventListener('scroll', onScroll, { passive: true });

    window.addEventListener('resize', () => {
      setActiveIndex(currentIndex, 'auto');
    });

    setActiveIndex(0, 'auto');
  }

  function initAll() {
    document.querySelectorAll('[data-banner-carousel]').forEach(initBannerCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
